<div style="padding: 20px 22px;">
  <!-- Header -->
  <div style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 16px;">
    <div style="flex: 1; min-width: 0;">
      <h2 style="margin: 0; font-size: 1.05rem; font-weight: 800; color: #111827;">
        ¿A dónde enviás?
      </h2>
      <p style="margin: 4px 0 0; font-size: 0.82rem; color: #6b7280;">
        Elegí el país y el método de pago. Los datos que pedimos después dependen del método.
      </p>
    </div>
    <button type="button" (click)="cerrar()" aria-label="Cerrar"
      style="background: none; border: none; cursor: pointer; color: #9ca3af; padding: 0; line-height: 1;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Paso 1: país -->
  <div style="font-size: 0.68rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 8px;">
    País de destino
  </div>

  <div *ngIf="data.countries.length === 0"
    style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 10px; padding: 12px 14px; color: #92400e; font-size: 0.84rem;">
    Por ahora no hay destinos disponibles. Intentá más tarde.
  </div>

  <div style="display: flex; flex-wrap: wrap; gap: 8px;">
    <button *ngFor="let c of data.countries" type="button" (click)="selectCountry(c.code)"
      [style.border]="countryCode === c.code ? '2px solid #1C593D' : '1px solid #d1d5db'"
      [style.background]="countryCode === c.code ? '#f0fdf4' : 'white'"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 14px; border-radius: 12px; cursor: pointer; min-height: 44px;">
      <img *ngIf="flagFor(c.code)" [src]="flagFor(c.code)" [alt]="c.name"
        style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover; flex-shrink: 0;" />
      <span style="font-size: 0.86rem; font-weight: 700; color: #111827;">{{ c.name }}</span>
    </button>
  </div>

  <!-- Paso 2: método -->
  <ng-container *ngIf="countryCode">
    <div style="font-size: 0.68rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; margin: 18px 0 8px;">
      Método de pago
    </div>

    <div *ngIf="variantsLoading" style="display: flex; justify-content: center; padding: 12px 0;">
      <mat-spinner diameter="22"></mat-spinner>
    </div>

    <div *ngIf="variantsError"
      style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 12px 14px; color: #b91c1c; font-size: 0.84rem;">
      {{ variantsError }}
    </div>

    <div *ngIf="!variantsLoading && !variantsError && variants.length === 0"
      style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 10px; padding: 12px 14px; color: #92400e; font-size: 0.84rem;">
      Este destino no tiene métodos de pago disponibles en este momento.
    </div>

    <div *ngIf="!variantsLoading && variants.length > 0" style="display: flex; flex-direction: column; gap: 8px;">
      <button *ngFor="let v of variants" type="button" (click)="variantCode = v.code"
        [style.border]="variantCode === v.code ? '2px solid #1C593D' : '1px solid #d1d5db'"
        [style.background]="variantCode === v.code ? '#f0fdf4' : 'white'"
        style="display: flex; align-items: center; gap: 10px; padding: 12px 14px; border-radius: 12px; cursor: pointer; text-align: left; min-height: 48px;">
        <mat-icon [style.color]="variantCode === v.code ? '#1C593D' : '#9ca3af'"
          style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">account_balance</mat-icon>
        <span style="flex: 1; min-width: 0;">
          <span style="display: block; font-size: 0.86rem; font-weight: 700; color: #111827;">{{ v.label || v.code }}</span>
          <span style="display: block; font-size: 0.74rem; color: #6b7280;">
            Recibe en {{ v.destinationCurrency }}<ng-container *ngIf="v.businessDays"> · {{ v.businessDays }} {{ v.businessDays === 1 ? 'día hábil' : 'días hábiles' }}</ng-container>
          </span>
        </span>
      </button>
    </div>
  </ng-container>

  <!-- Error al cargar el formulario -->
  <div *ngIf="schemaError"
    style="margin-top: 14px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 12px 14px; color: #b91c1c; font-size: 0.84rem;">
    {{ schemaError }}
  </div>

  <!-- Acciones -->
  <div style="display: flex; gap: 8px; border-top: 1px solid #e5e7eb; padding-top: 14px; margin-top: 18px;">
    <button type="button" (click)="cerrar()" [disabled]="loadingSchema"
      style="padding: 10px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;">
      Cancelar
    </button>
    <button type="button" (click)="continuar()" [disabled]="!puedeContinuar"
      [style.opacity]="puedeContinuar ? '1' : '0.5'"
      [style.cursor]="puedeContinuar ? 'pointer' : 'not-allowed'"
      style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem;">
      <mat-spinner *ngIf="loadingSchema" diameter="18" class="spinner-en-boton"></mat-spinner>
      Continuar
    </button>
  </div>
</div>
